import { createFileRoute } from '@tanstack/react-router';
import { PageStub } from '@/components/shared/PageStub';

export const Route = createFileRoute('/marketing/sales')({
  component: () => <PageStub title="Sales Hub" description="Sales pipeline and tools" />,
});
